import React from 'react';
import ConnectionItem from './ConnectionItem';

const ConnectionList = ({ connections }) => {
  if (connections.length === 0) {
    return <p>No active connections.</p>;
  }

  return (
    <div>
      {connections.map((connection, index) => (
        <ConnectionItem key={connection.channel_name || index} connection={connection} />
      ))}
    </div>
  );
};

export default ConnectionList;
